import React from 'react';
import {
  Drawer,
  makeStyles,
  IconButton,
  AppBar,
  Toolbar,
  Button,
  styled,
} from '@material-ui/core';
import { EditOutlined, ArrowBack } from '@material-ui/icons';
import { useIntl } from 'react-intl';

import translations from 'utils/translations';
import { SdmStack } from '../SdmStack';
import { FormSubmitEnum } from 'utils/drupalEntities';

const useStyles = makeStyles((theme) => ({
  paper: {
    boxShadow: theme.shadows[4],
  },
}));

const StyledButton = styled(Button)(({ fontSize = 12 }) => ({
  fontSize: fontSize,
  borderRadius: 0,
}));

export const ContentGeneratorDrawer = ({
  open,
  onOpen,
  onBtnClicked,
  anchor = 'right',
  children,
  hideLangBtn = false,
  hideApprovalBtn = false,
  hideButtons = false,
  productLangCode,
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const i18n = translations.productPage(intl);

  return (
    <Drawer
      classes={{
        paper: classes.paper,
      }}
      open={open}
      variant={!open ? 'permanent' : 'temporary'}
      anchor={anchor}
    >
      {!open && (
        <IconButton onClick={onOpen}>
          <EditOutlined />
        </IconButton>
      )}
      {open && (
        <div>
          <AppBar position="sticky" color="default">
            <Toolbar
              component={SdmStack}
              direction="row"
              spacing={5}
              justifyContent="space-between"
            >
              <StyledButton
                color="primary"
                onClick={() => onBtnClicked(FormSubmitEnum.BACK)}
                startIcon={<ArrowBack />}
                fontSize={11}
              >
                {i18n.buttons.back}
              </StyledButton>
              {!hideButtons ? (
                <SdmStack direction="row" spacing={1}>
                  {!hideLangBtn ? (
                    <StyledButton
                      disableElevation
                      variant="contained"
                      color="secondary"
                      onClick={() => onBtnClicked(FormSubmitEnum.TRANSLATE)}
                      style={{ backgroundColor: 'rgba(145, 158, 171, 0.8)' }}
                    >
                      {
                        i18n.buttons[
                          productLangCode?.toLowerCase() === 'it'
                            ? 'goToEn'
                            : 'goToIt'
                        ]
                      }
                      <img
                        src={`/themes/custom/sdm/images/drawer/${
                          productLangCode?.toLowerCase() === 'it'
                            ? 'uk'
                            : 'italy'
                        }-flag.png`}
                        style={{ marginLeft: 5, marginBottom: 3 }}
                      />
                    </StyledButton>
                  ) : null}
                  <StyledButton
                    disableElevation
                    variant="outlined"
                    color="primary"
                    onClick={() => onBtnClicked(FormSubmitEnum.PREVIEW)}
                  >
                    {i18n.buttons.preview}
                    {/* <StyledInfo color="primary" fontSize="small" /> */}
                  </StyledButton>
                  <StyledButton
                    disableElevation
                    variant="contained"
                    color="secondary"
                    onClick={() => onBtnClicked(FormSubmitEnum.DRAFT)}
                  >
                    {i18n.buttons.save}
                  </StyledButton>
                  {!hideApprovalBtn ? (
                    <StyledButton
                      disableElevation
                      variant="contained"
                      color="primary"
                      onClick={() => onBtnClicked(FormSubmitEnum.PUBLISH)}
                    >
                      {i18n.buttons.approval}
                    </StyledButton>
                  ) : null}
                </SdmStack>
              ) : null}
            </Toolbar>
          </AppBar>
          {children}
        </div>
      )}
    </Drawer>
  );
};
